import apiClient from '../../../../services/apiClient';
import api from '../../../../services/apiClient';

import { transformToServer } from '../components/GroupDetail/data';


export async function getKindergartenInfo({id}){

    const endpoint = `kindergartens/${id}`;

    const parameters = [];

    const info = await api.get(endpoint + ( parameters.length > 0 ? `?${parameters.join("&")}` : '') );

    return (info && info.data && info.data[0]) || null;

}

export async function getGroupsArchiveInfo(id, period){

    const url = `kindergartens/${id}/groups_archive?year=${period}`;

    const info = await api.get(url);

    return (info && info.data && info.data[0]) || null;
}



const getDateFrom = () => {
    const [yy, mm] = (new Date().toISOString()).split('T')[0].split('-').map(l=>+l);
    return `${mm > 8 ? yy : yy -1}-08-31`;
}

export async function getChildrenListInfo({id, group_id, date_to= new Date().toISOString(), date_from = getDateFrom(), archives, period, selectedDate}) {

    const endpoint = archives ? 
    `kindergartens/${id}/children/main_info?groups=${group_id}&date_to=${selectedDate}&date_from=${period}-09-01&archives=true`
    : `kindergartens/${id}/children/main_info?groups=${group_id}&date_to=${selectedDate}${archives ? '&archives=true' : ''}`;
    //&date_from=${date_from}`;

    const info = await api.get(endpoint);

    return info.data || [];
}

export async function getChildrenListInfoLeft({id, group_id, period, selectedDate}){

    const endpoint = `kindergartens/${id}/children/main_info_left?groups=${group_id}&date_to=${selectedDate}`;

    const info = await api.get(endpoint);

    return info.data || [];
}

export async function addNewGroup(data, kg_id){

    const url = `kindergartens/${kg_id}/groups/current_period`;

    const result = await apiClient.post(url, transformToServer(data, "new"));

    return result;

}

export async function deleteGroup(kg_id, gr_id){

    const url = `kindergartens/delete_empty_group`;
    const data = { kg_id, gr_id};

    const result = await apiClient.put(url, data);

    return result;
}

export async function editGroup(kg_id, gr_id, data){

    const url = `kindergartens/${kg_id}/groups/${gr_id}/main_info`;
   
    const result = await apiClient.put(url, transformToServer(data, "edit"));

    return result;
}

export async function archiveGroup(kg_id, gr_id){

    const url = `kindergartens/${kg_id}/archive_groups_single_id/${gr_id}`;
    const data = {};

    const result = await apiClient.post(url, data);

    return result;
}


export async function removeChildDuplicate(kgId, grId, childId) {
    const endpoint = `kindergartens/${kgId}/groups/${grId}/child_similar/${childId}`;
    
    try {
        const result = await apiClient.delete(endpoint);
        return result.data;
    } catch (error) {
        console.error('Error removing duplicate:', error);
        throw error;
    }
}

export async function restoreChild(childId, kgId, periodStartYear, groupNumber) {
    const endpoint = `children/${childId}/reestablish/kindergarten/${kgId}?periodStartYear=${periodStartYear}&groupNumber=${groupNumber}`;
    
    try {
        const result = await apiClient.post(endpoint, {});
        return result.data;
    } catch (error) {
        console.error('Error restoring child:', error);
        throw error;
    }
}